/**
 * Converts a number to its ordinal form (e.g., 1 → "1st", 2 → "2nd", 3 → "3rd")
 * @param {number} num - The number to convert to ordinal form
 * @returns {string} The ordinal string representation of the number
 */
export function getOrdinal(num: number): string {
  if (num % 100 >= 11 && num % 100 <= 13) {
    return `${num}th`;
  }

  switch (num % 10) {
    case 1:
      return `${num}st`;
    case 2:
      return `${num}nd`;
    case 3:
      return `${num}rd`;
    default:
      return `${num}th`;
  }
}
